import { render, staticRenderFns } from "./Blocs.vue?vue&type=template&id=a1ee95b8"
import script from "./Blocs.vue?vue&type=script&lang=js"
export * from "./Blocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1ee95b8')) {
      api.createRecord('a1ee95b8', component.options)
    } else {
      api.reload('a1ee95b8', component.options)
    }
    module.hot.accept("./Blocs.vue?vue&type=template&id=a1ee95b8", function () {
      api.rerender('a1ee95b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/blocs/Blocs.vue"
export default component.exports